export default "__VITE_ASSET__d7kQpMmJ__"